function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-1-1h34v34H-1z"
});

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  fill: "#243143",
  r: 16,
  cy: 16,
  cx: 16
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.707 16.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l6-6a1 1 0 00-1.414-1.414L14 17.586l-1.293-1.293z"
}));

function SvgCheckCircle16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiA8IS0tIENyZWF0ZWQgd2l0aCBTVkcgRWRpdG9yIC0gaHR0cDovL2dpdGh1Yi5jb20vbXphbGl2ZS9TVkcgRWRpdG9yLyAtLT4KIDxnPgogIDx0aXRsZT5iYWNrZ3JvdW5kPC90aXRsZT4KICA8cmVjdCBmaWxsPSIjZmZmIiBpZD0iY2FudmFzX2JhY2tncm91bmQiIGhlaWdodD0iMzQiIHdpZHRoPSIzNCIgeT0iLTEiIHg9Ii0xIi8+CiA8L2c+CiA8Zz4KICA8dGl0bGU+TGF5ZXIgMTwvdGl0bGU+CiAgPGNpcmNsZSBpZD0ic3ZnXzIiIGZpbGw9IiMyNDMxNDMiIHI9IjE2IiBjeT0iMTYiIGN4PSIxNiIvPgogIDxwYXRoIGlkPSJzdmdfMyIgZmlsbD0id2hpdGUiIGQ9Im0xMi43MDcxLDE2LjI5MjljLTAuMzkwNSwtMC4zOTA1IC0xLjAyMzcsLTAuMzkwNSAtMS40MTQyLDBjLTAuMzkwNSwwLjM5MDUgLTAuMzkwNSwxLjAyMzcgMCwxLjQxNDJsMiwyYzAuMzkwNSwwLjM5MDUgMS4wMjM3LDAuMzkwNSAxLjQxNDIsMGw2LC02YzAuMzkwNSwtMC4zOTA1IDAuMzkwNSwtMS4wMjM3IDAsLTEuNDE0MmMtMC4zOTA1LC0wLjM5MDUgLTEuMDIzNywtMC4zOTA1IC0xLjQxNDIsMGwtNS4yOTI5LDUuMjkyOWwtMS4yOTI5LC0xLjI5Mjl6Ii8+CiA8L2c+Cjwvc3ZnPg==";
export { SvgCheckCircle16 as ReactComponent };